<template>
  <Row>
    <Col span="24">
      <Card
        class="sum-card-box"
        :padding="0"
        style="border: 0px solid #efefef; background: #f1f1f1"
      >
        <Table stripe :columns="columns1" :data="data1"></Table>
      </Card>
    </Col>
  </Row>
</template>
<script>
import Change from "../../workOrder/change.vue";

export default {
  name: "progressCenter",
  components: {},
  data() {
    return {
      columns1: [
        {
          title: "报修时间",
          minWidth: 110,
          align: "left",
          key: "repairTime",
          sortable: true,
        },
        {
          title: "所在科室",
          key: "department",
          minWidth: 100,
          align: "left",
          render: (h, params) => {
            const row = params.row;
            const text = row.department;
            return h(
              "div",
              {
                style: {
                  margin: "5px",
                  "font-size": "14px",
                  width: "150px",
                  overflow: "hidden",
                  "text-overflow": "ellipsis",
                  "white-space": "nowrap",
                },
              },
              text
            );
          },
        },
        {
          title: "工单类型",
          key: "typeName",
          minWidth: 100,
          align: "left",
          copy: true,
        },
        {
          title: "问题描述",
          key: "descr",
          width: 250,
          align: "left",
        },
        {
          title: "联系电话",
          key: "deskPhone",
          minWidth: 122,
          align: "left",
          copy: true,
        },
        {
          title: "报修来源",
          key: "repairSource",
          minWidth: 110,
          align: "left",
          render: (h, params) => {
            const row = params.row;
            const text =
              row.repairSource == 1
                ? "医院提交"
                : row.repairSource == 2
                ? "维修员提交"
                : row.repairSource == 3
                ? "后台提交"
                : "";
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
        {
          title: "处理人",
          key: "maintainerName",
          minWidth: 120,
          align: "left",
        },
        // {
        //   title: '资产名称',
        //   key: 'facilityName',
        //   minWidth: 120,
        //   align: 'left',
        // },
        // {
        //   title: '资产二维码',
        //   key: 'qrCode',
        //   minWidth: 120,
        //   align: 'center',
        //   viewimage: true,
        // },
        // {
        //   title: '派单类型',
        //   key: 'sendType',
        //   minWidth: 100,
        //   align: 'left',
        //   render: (h, params) => {
        //     const row = params.row
        //     const text = row.sendType == 1 ? '手动派单' : row.sendType == 2 ? '自动派单' : ''
        //     return h(
        //       'div',
        //       {
        //         style: {
        //           margin: '5px',
        //           'font-size': '14px',
        //           width: '150px',
        //           overflow: 'hidden',
        //           'text-overflow': 'ellipsis',
        //           'white-space': 'nowrap',
        //         },
        //       },
        //       text
        //     )
        //   },
        // },

        // {
        //   title: '状态',
        //   key: 'state',
        //   minWidth: 100,
        //   align: 'left',
        //   render: (h, params) => {
        //     const row = params.row
        //     const text = row.state == 1 ? '待处理' : row.state == 2 ? '处理中' : row.state == 3 ? '已完成' : ''
        //     return <span style={{ 'font-size': '14px' }}>{text}</span>
        //   },
        // },
        {
          title: "操作",
          align: "center",
          minWidth: 120,
          key: "action",
          fixed: "right",
          render: (h, params) => {
            let row = params.row;
            return h(
              "div",
              {
                style: {
                  display: "flex",
                },
              },
              [
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                      color: "#66A2FF",
                    },
                    on: {
                      click: () => {
                        this.toChange(row);
                      },
                    },
                  },
                  "转单"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      color: "#FF3636",
                    },
                    on: {
                      click: () => {
                        this.toInfo(row);
                      },
                    },
                  },
                  "详情"
                ),
              ]
            );
          },
        },
      ],
      data1: [],
    };
  },
  computed: {
    isSystem() {
      return $utils.data.get("auth", "is_system") || false;
    },
  },
  created() {
    this.loadHomeData();
  },
  methods: {
    loadHomeData() {
      let url = "/admin/system/work/list";
      let q = {};
      q.pageNum = 1;
      q.pageSize = 4;
      q.query = { state: 1 };
      q.state = 1;
      $utils.api.load(url, q).then((res) => {
        if (res.code == 200) {
          let arr = res.rows;
          if (arr.length >= 4) {
            this.data1 = arr.slice(0, 3);
          } else {
            this.data1 = arr;
          }
        }
      });
      console.log(this.data1);
    },
    //转单
    toChange(row) {
      this.$Modal.success({
        closable: true,
        title: "转单",
        width: "1000px",
        // okButtonProps:{ style: { display: 'none' } },
        // footerHide: true,
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <Change
              style={{ margin: "0", color: "#19be6b" }}
              id={row.id}
              typeId={row.typeId}
            ></Change>
          );
        },
      });
    },
    //详情
    toInfo(row) {
      $utils.url.push({
        name: "workOrder_info",
        query: { action: "edit", kv: row.id, workId: row.id },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.sum-card-box {
  float: left;
  width: 100%;
  height: 260px;
  margin-top: 10px;
  margin-bottom: 10px;
  box-sizing: border-box;
  background-color: #f9f9f9;
  transition: 0.2s all ease;
  position: relative;
  padding: 20px 24px 8px;

  .header_box {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }

  .header_br {
    width: 4px;
    height: 20px;
    background-color: rgb(228, 4, 19);
  }

  .header_title {
    font-family: SourceHanSansSC;
    font-weight: 700;
    font-size: 15px;
    color: rgb(16, 16, 16);
    font-style: normal;
    letter-spacing: 0px;
    text-decoration: none;
    margin-left: 10px;
  }

  .work_title {
    width: 72px;
    height: 35px;
    border-bottom: 3px solid rgba(228, 4, 19, 1);
    line-height: 35px;
    text-align: left;
    color: rgba(228, 4, 19, 1);
    font-size: 14px;
  }

  .box {
    display: flex;
    align-items: center;
    margin-top: 20px;

    .item {
      display: flex;
      align-items: center;
      justify-items: center;
      flex-direction: column;
      margin-left: 15px;
      margin-right: 35px;

      .image {
        width: 50px;
        height: 60px;
        background: #ccc;
      }

      .title {
        font-family: SourceHanSansSC;
        font-weight: 400;
        font-size: 14px;
        color: rgb(16, 16, 16);
        font-style: normal;
        margin-top: 10px;
      }
    }
  }

  .item3 {
    height: 0px;
    margin-bottom: 2px;
    width: 100%;
  }

  .item4 {
    border-top: 1px solid #e8e8e8;
    padding-top: 5px;
    margin-top: 8px;
    font-size: 14px;
    line-height: 22px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    span:last-child {
      margin-left: 8px;
      color: rgba(0, 0, 0, 0.85);
    }
  }
}
</style>
